import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { serializeSnProductMappingCommand } from './serialize';

/**
 * 啟用 物料序號。body 只有 updated_at。
 * POST `/aftersales/sn-product-mapping/{id}/activate`
 *
 * @param {string} id
 * @param {object} payload
 */
export async function activateSnProductMapping(id, payload = {}) {
  const { data: raw } = await request.post(
    `/aftersales/sn-product-mapping/${id}/activate`,
    serializeSnProductMappingCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
